import React from "react";
import { T } from "Components";

import DashboardCard from "./DashboardCard";
import useStatistics from "../../Infrastructure/useStatistics";
import { FormatCompactCurrency, FormatNumber } from "../../Infrastructure/format";

/** Kova → renk token'ı. 90+ gün kırmızı: etiket, bar ve tutar birlikte vurgulanır. */
const BUCKET_TONE = {
  Days0To30: "teal",
  Days31To60: "primary",
  Days61To90: "amber",
  Days90Plus: "red",
};

const ReceivableAging = ({ onNavigate }) => {
  const { data, loading, error } = useStatistics("/Statistics/ReceivableAging", []);

  const rows = Array.isArray(data) ? data : [];
  const total = rows.reduce((sum, row) => sum + row.Amount, 0);
  const compactTotal = FormatCompactCurrency(total);

  return (
    <DashboardCard
      title={T.Main("Dashboard.Statistics.ReceivableAging")}
      description={`${T.Main("Dashboard.Statistics.Total")} ${compactTotal.value}${
        compactTotal.unit ? ` ${compactTotal.unit}` : ""
      }`}
      // Gezinme yoksa (ör. admin Birlik Özeti) bağlantı gösterilmez
      action={onNavigate ? T.Main("Dashboard.Statistics.GoToReport") : undefined}
      onAction={() => onNavigate && onNavigate("/Report/Collection/Detail")}
      loading={loading}
      error={error}
      empty={rows.length === 0}
      bodyClassName="fdash__aging"
    >
      <div className="fdash__aging__head">
        <span>{T.Main("Dashboard.Statistics.DueRange")}</span>
        <span>{T.Main("Dashboard.Statistics.Amount")}</span>
        <span>{T.Main("Dashboard.Statistics.Member")}</span>
      </div>

      {rows.map((row) => {
        const tone = BUCKET_TONE[row.Bucket] ?? "primary";
        const amount = FormatCompactCurrency(row.Amount);

        return (
          <div className="fdash__aging__row" key={row.Bucket}>
            <div className="fdash__aging__bucket">
              <b style={{ color: `var(--${tone})` }}>{row.Label}</b>
              <i
                style={{
                  background: `var(--${tone})`,
                  width: `${Math.min(Math.max(row.Ratio, 0), 100)}%`,
                }}
              />
            </div>
            <span className="fdash__aging__amount" style={{ color: `var(--${tone})` }}>
              {amount.value}
              {amount.unit ? ` ${amount.unit}` : ""}
            </span>
            <span className="fdash__aging__count">{FormatNumber(row.MemberCount)}</span>
          </div>
        );
      })}
    </DashboardCard>
  );
};

export default ReceivableAging;
